import React from 'react';
import PropTypes from 'prop-types';

function Coins(props) {
  const { height, width } = props;
  return (
    <svg
      width={width || '200'}
      height={height || '200'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.59961 11.25C13.7417 11.25 17.0996 9.73896 17.0996 7.875C17.0996 6.01104 13.7417 4.5 9.59961 4.5C5.45747 4.5 2.09961 6.01104 2.09961 7.875C2.09961 9.73896 5.45747 11.25 9.59961 11.25Z"
        stroke="#63666A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.09961 7.875V11.625C2.09961 13.4906 5.45586 15 9.59961 15C13.7434 15 17.0996 13.4906 17.0996 11.625V7.875"
        stroke="#63666A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.59961 10.9688V14.7188"
        stroke="#63666A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0996 9.06561C20.5215 9.38436 23.0996 10.7437 23.0996 12.375C23.0996 14.2406 19.7434 15.75 15.5996 15.75C13.7621 15.75 12.0746 15.45 10.7715 14.9625"
        stroke="#63666A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.09961 14.9344V16.125C8.09961 17.9906 11.4559 19.5 15.5996 19.5C19.7434 19.5 23.0996 17.9906 23.0996 16.125V12.375"
        stroke="#63666A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5996 15.4688V19.2188"
        stroke="#63666A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5996 10.9688V19.2188"
        stroke="#63666A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Coins.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

Coins.defaultProps = {
  height: undefined,
  width: 22
};

export default Coins;
